module.exports = __webpack_public_path__ + "assets/tianping.876a519a.svg";